/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { Component, useState } from 'react';
import { StyleSheet, View, TextInput } from 'react-native';

interface PinInputProps {
  digits: number;
  placeholder?: string;
  onInputChange: (value: string) => void;
  fields?: string[];
  [key: string]: unknown;
}

interface PinInputState {
  fields: string[];
}

class PinInput extends Component<PinInputProps, PinInputState> {
  inputRefs: Array<{ getNativeRef: () => { focus: () => void } }> = [];
  digits: string[] = [];

  state = {
    fields: [] as string[],
  };

  onChange(fields: string, index: number) {
    const { digits } = this.props;
    this.digits[index] = fields;
    this.setState({ fields: this.digits });
    this.props.onInputChange(this.state.fields.join(''));
    if (!fields) {
      if (index) {
        this.setInputFocus(index - 1);
      }
      return;
    }
    if (index < (digits > 6 ? 5 : digits - 1)) {
      this.setInputFocus(index + 1);
    }
  }

  setInputFocus(index: number) {
    this.inputRefs[index].getNativeRef().focus();
  }

  keyPressHandler(e: { nativeEvent: { key: string } }, i: number) {
    if (e.nativeEvent.key === 'Backspace' && i > 0) {
      this.setInputFocus(i - 1);
    }
  }

  render() {
    const { placeholder, digits, ...rest } = this.props;
    const addInputFields = [...Array(digits > 6 ? 6 : digits)];
    return (
      <View style={styles.container}>
        {addInputFields.map((x, index) => {
          return (
            <TextInput
              {...rest}
              key={index}
              editable={!this.props.fields}
              value={this.props.fields?.[index] != null ? String(this.props.fields[index]) : ''}
              selectTextOnFocus={true}
              onKeyPress={(e: { nativeEvent: { key: string } }) => this.keyPressHandler(e, index)}
              ref={(ref: unknown) =>
                (this.inputRefs[index] = ref as { getNativeRef: () => { focus: () => void } })
              }
              autoCapitalize="none"
              placeholder={placeholder}
              keyboardType="numeric"
              maxLength={1}
              onChangeText={(text: string) => this.onChange(text, index)}
            />
          );
        })}
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
});

export default PinInput;
